import {IAbstractCell, ICell} from "@/model/Locker/lockerInterfaces";

export enum IModuleType {
  master = 1,
  tintoreria = 2,
  paqueteria = 3,
  mix = 4,
  masterZ2 = 14,
  masterZ3 = 15,
  masterZ4 = 5,
  paqueteriaZ = 6,
  mixZ16 = 26,
  mixZ14 = 27,
  mixZ10 = 31,
  mixZ10D = 28,
  mixZ12D = 30,
  mixZ15D = 29,
  mixZ = 7,
  Z2comp = 16,
  Z3comp = 19,
  Z4comp = 13,
  Z4compC = 22,
  Z5comp = 8,
  Z6comp = 12,
  Z7comp = 11,
  Z8comp = 10,
  Z9comp = 18,
  Z9CompXL = 21,
  Z10comp = 17,
  Z10compXLA = 23,
  Z10compXLB = 24,
  Z11comp = 9,
  Z12comp = 25,
  ZMaster7 = 20,
  screenOnly = 89,
  crap = 99,
}

export enum IModuleDirection {
  x = '',
  left = 'left',
  below = 'below',
  right = 'right',
}

export enum ICellSIzeId {
  largo = 1, // XXL
  mediano = 2, // M
  estandar = 3, // S
  grande = 4, // L
  storageStandard = 5, // XL
}

export interface IAbstractModule {
  type: IModuleType;
  // name can differentiate alt mapping on same module type
  name: string;
  hasScreen: boolean;
  columns: IAbstractCell[][];
}

export interface IModule {
  type: IModuleType;
  block: number;
  direction: IModuleDirection;
  hasScreen: boolean;
  blocked_column: boolean;
  column_order: number;
  columns: ICell[][];
}
